import { W as WuiCloseButton$1, d as defineCustomElement$1 } from './p-B5nMSUwj.js';

const WuiCloseButton = WuiCloseButton$1;
const defineCustomElement = defineCustomElement$1;

export { WuiCloseButton, defineCustomElement };
